<template>
  <b-modal
    no-close-on-backdrop
    hide-footer
    ref="VoucherSearchModalRef"
    id="vouchermodal"
    title="Nº de Vale"
  >
    <b-list-group>     
      <b-form-input
        id="voucherNo"
        type="text"
        v-model="voucherNo"
        required
        placeholder="Nº de vale..."
      ></b-form-input>
      <b-btn class="mt-3" variant="outline-success" @click="GetVoucherBalance()"
        >Buscar vale</b-btn
      >
      <b-list-group>
        <p class="my-4">
          SALDO: {{ parseFloat(voucherAmount).toFixed(2) + " €" }}
        </p>
      </b-list-group>
      <b-btn
        class="mt-3"
        variant="outline-success"
        @click="PrintVoucher(0)"
        >Imprimir vale</b-btn
      >
      <b-btn class="mt-3" variant="outline-danger" @click="VoucherModalClose()"
        >Cerrar</b-btn
      >
    </b-list-group>
  </b-modal>
</template>

<script>
import ticketPrint from "@/components/ticketPrint.js";

export default {
  mixins: [ticketPrint],
  name: "voucherModal",
  data() {
    return {
      voucherNo: "",
      voucherAmount: ""
    };
  },
  mounted: function () {
   console.log("vmcreated");
   this.$refs.VoucherSearchModalRef.show();
  },
  methods: {
    GetVoucherBalance() {
      this.axios
        .post(
          this.ApiBaseUrl + "Sales/VoucherBalance",
          JSON.stringify(this.voucherNo),
          { headers: { "Content-Type": "application/json" } }
        )
        .then((response) => {
          this.voucherAmount = response.data[0];
        });
    },
    PrintVoucher(regalo) {
     
      
        let strprintdoc = "@@" + regalo + this.voucherNo;

        var ticketPrintReq = {
          printdoc: strprintdoc,
          ticketPrinter: localStorage.getItem("ticketPrinter"),
          ticketControllerURL: window.location.origin + this.ApiBaseUrl + "Tickets/GetPrintVoucherCmd"    
        };

        console.log(ticketPrintReq);
        this.OpenSocket(JSON.stringify(ticketPrintReq));        
      
    },
    VoucherModalClose()
    {
        this.$store.commit("setVoucherModal", 0);
    }
  },
};
</script>

<style scoped>
</style>